const H1: React.FC<{
  children: string;
}> = ({ children }) => <h1 className="statement-3 hyphens">{children}</h1>;

export default H1;
